import { apiClient } from '@/core/api/client';
import type {
  CommunicationAssetData,
  WebinarLinkData,
  AdvisorAcceleratorLinkData,
  UpdateCommunicationAssetPayload,
  UpdateWebinarLinkPayload,
  UpdateAdvisorAcceleratorLinkPayload,
} from '../types/fp-resources.types';

const BASE = '/admin/fp-resources';

// --- Communication Asset (per-FP) ---

export async function getCommunicationAsset(fpId: string): Promise<CommunicationAssetData> {
  const res = await apiClient.get<CommunicationAssetData>(`${BASE}/advisors/${fpId}/communication-asset`);
  return res.data;
}

export async function saveCommunicationAsset(
  fpId: string,
  payload: UpdateCommunicationAssetPayload,
): Promise<CommunicationAssetData> {
  const res = await apiClient.put<CommunicationAssetData>(
    `${BASE}/advisors/${fpId}/communication-asset`,
    payload,
  );
  return res.data;
}

export async function deleteCommunicationAsset(fpId: string): Promise<void> {
  await apiClient.delete(`${BASE}/advisors/${fpId}/communication-asset`);
}

// --- Webinar Link (singleton) ---

export async function getWebinarLink(): Promise<WebinarLinkData> {
  const res = await apiClient.get<WebinarLinkData>(`${BASE}/webinar-link`);
  return res.data;
}

export async function saveWebinarLink(payload: UpdateWebinarLinkPayload): Promise<WebinarLinkData> {
  const res = await apiClient.put<WebinarLinkData>(`${BASE}/webinar-link`, payload);
  return res.data;
}

export async function deleteWebinarLink(): Promise<void> {
  await apiClient.delete(`${BASE}/webinar-link`);
}

// --- Advisor Accelerator Link (singleton) ---

export async function getAdvisorAcceleratorLink(): Promise<AdvisorAcceleratorLinkData> {
  const res = await apiClient.get<AdvisorAcceleratorLinkData>(`${BASE}/advisor-accelerator-link`);
  return res.data;
}

export async function saveAdvisorAcceleratorLink(
  payload: UpdateAdvisorAcceleratorLinkPayload,
): Promise<AdvisorAcceleratorLinkData> {
  const res = await apiClient.put<AdvisorAcceleratorLinkData>(
    `${BASE}/advisor-accelerator-link`,
    payload,
  );
  return res.data;
}

export async function deleteAdvisorAcceleratorLink(): Promise<void> {
  await apiClient.delete(`${BASE}/advisor-accelerator-link`);
}
